export default __webpack_public_path__ + "static/media/Look at me III.e1f897b5.jpg";